import AwardsCards from "./Cards/AwardsCard";
// import vapourHill from ".././assets/img/Hackathon.png";
import ScrollReveal from "./Hooks/ScrollReveal";
import { useEffect } from "react";
import simpleParallax from "simple-parallax-js";


const Awards = ({ awardsData }) => {
    useEffect(() => {
        var image = document.getElementById('parallax2');
        new simpleParallax(image, {
            maxTransition: 80,
            delay: .6,
            transition: 'cubic-bezier(0,0,0,1)'
        });
    }, []);
    return (
        <>
            {awardsData.display &&
                <section className="pt-10 mt-20 sm:mt-40 sm:flex sm:justify-center sm:flex-col  " id="work">
                    <div>
                        <ScrollReveal>
                            <h1 className="uppercase text-lg sm:text-2xl font-openSans font-semibold sm:text-center">Awards &amp; Achievements</h1>
                        </ScrollReveal>
                        <ScrollReveal>
                            <h1 className="uppercase my-4 sm:mt-3 sm:mb-10 text-sm sm:text-lg font-openSans font-semibold underline underline-offset-1 sm:text-center">Hackathons</h1>
                        </ScrollReveal>
                    </div>

                    <div className="sm:flex sm:flex-row sm:justify-around">

                        <div className="min-w-40">
                            {awardsData.awards.map((Element, index) => (
                                <ScrollReveal>
                                    <AwardsCards
                                        key={index}
                                        index={`0${index + 1}`}
                                        position={Element.position}
                                        host={Element.host}
                                        hackathon={Element.hackathon}
                                        date={Element.date}
                                        moreInfo={Element.moreInfo}
                                    />
                                </ScrollReveal>
                            ))
                            }
                        </div>

                        {/* <div className=" mt-10 ml-20" >
                            <div className='hidden sm:block bg-gray-300 h-full  w-80 max-width-80  bg-cover bg-top'
                                style={{ backgroundImage: `url(${vapourHill}) ` }}>
                            </div>
                        </div> */}

                        <div className='hidden sm:block bg-none h-full  w-72 hmax360 sm:pt-10 overflow-hidden'
                        >
                            {/* <div className='mt-4 bg-gray-300 h-20 sm:h-40   bg-cover bg-center'
                 style={{ backgroundImage: `url(${vapourHill}) ` }} >
               </div> */}
                            <ScrollReveal>
                                <img src={awardsData.picture} alt="" id="parallax2" className="mt-4 bg-img h-auto  " />
                                
                            </ScrollReveal>
                        </div>

                    </div>
                </section>}
        </>
    );
};

export default Awards;